module.exports = __webpack_public_path__ + "assets/img/fisfisa-we.f35b8e60.jpg";